import { render } from "./InputText.vue?vue&type=template&id=28479556&scoped=true&ts=true"
import script from "./InputText.vue?vue&type=script&lang=ts"
export * from "./InputText.vue?vue&type=script&lang=ts"

import "./InputText.vue?vue&type=style&index=0&id=28479556&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28479556"]])

export default __exports__